import {
    faCalendar,
    faCalendarDay,
    faEllipsisVertical,
    faFileCsv,
    faFileExport,
    faFileImport,
    faPencil,
    faPlus,
    faUser,
    faUserPlus,
    faUserXmark,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconLayout2, IconListDetails, IconShare3 } from "@tabler/icons-react"
import { Button, Dropdown, Nav } from "react-bootstrap"
import { customStyles, handleExportData } from "../../Utils/helpers/commonhelper"
import { FilterPagination } from "../../pages/FIlterPagination"
import { DropdownItemWithActions } from "../../pages/DropdownItemWithActions"
import Select, { components } from "react-select"
import { Filter } from "../../pages/Filter"
import { imageURL } from "../../Utils/constants/constant"
import { useNavigate } from "react-router-dom"
import useLocalStorageState from "use-local-storage-state"
import { PipelineShareModal } from "../../pages/PipelineShareModal"
import { useEffect, useMemo, useRef, useState } from "react"
import { DeleteRequest, GetRequest, PutRequest } from "../../Utils/hooks/ApiHandler"
import { toast } from "sonner"
import face1 from "../../Utils/assets/img/faces/5.jpg"
import face2 from "../../Utils/assets/img/faces/6.jpg"
import face3 from "../../Utils/assets/img/faces/7.jpg"
import DeleteModal from "../DeleteModal"
import useCommonData from "../../Utils/actions/advanceFilteringAction"
import { ColumnConfigurator } from "../../pages/ColumnConfigurator"
import { useOutsideClickHandler } from "../../Utils/hooks/useOutsideClickHandler"
import { ManageListDropdown } from "../../pages/ManageListDropdown"

export const DealHeader = ({
    permissionAssigned,
    canEdit_canDownload,
    currView,
    setCurrView,
    dealGrant,
    heading,
    setHeading,
    parsedSharedUsers,
    setActiveOffset,
    dealsData,
    handleAddDeal,
    selectedPipelineId,
    setSelectedPipelineId,
    pipedLines,
    pipelineStages,
    encodePipelineId,
    setDebouncedSearch,
    filterCategories,
    setFilterCategories,
    currentFilterType,
    selectedPipeline,
    filterStates,
    setEncodedId,
    selectedStageId,
    setCreatePipeline,
    setEditPipeline,
    setFilterState,
    queryKey,
    dealsApiData,
    setTempFilterData,
    columns,
    setColumns,
    columnOptions
}) => {

    // Session storage and authentication setup
    const [customer, setCustomer] = useLocalStorageState("customer")
    const navigate = useNavigate()
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication

    // API headers configuration
    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }

    const [isDeleting, setIsDeleting] = useState(false)
    // pipeline share modal state
    const [shareModal, setShareModal] = useState(false)
    // state for storing the owner who created the current pipeline
    const [added_by, setAddedBy] = useState(null)
    // filter seazrch bar input state
    const [filterSearchInput, setFilterSearchInput] = useState("")

    // fitered categories to store the search input filter categories
    const [filteredCategories, setFilteredCategories] = useState([])

    // filter state to store the data to pass to delete and edit handler for filter
    const [filterData, setFilterData] = useState(null)
    // edit value state fot the filter card name edit
    const [editValue, setEditValue] = useState()
    // delete state for filter
    const [confirmFilterDelete, setFilterDelete] = useState(false)

    // Add states for filter pagination and search
    const [filterOffset, setFilterOffset] = useState(0)
    const filterLimit = 5
    const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("")
    const [filterPageCount, setFilterPageCount] = useState(0)
    // isediting state for undoing the edit state in the filter name update in the heading dropdown
    const [editingId, setEditingId] = useState(false)
    // filter state to see the temoporary applied filter data,
    // const [tempFilterData, setTempFilterData] = useState(null)
    // state for filter dropdown of quotations
    const [filterDropdown, setFilterDropdown] = useState(false)

    // for dropdown of the filter cards being created by the user
    const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false)
    const filterCategoriesDropRef = useRef(null)
    // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
    const [isInitialized, setIsInitialized] = useState(false)
    // Search states for debounced search
    const [searchInput, setSearchInput] = useState("")
    useEffect(() => {
        if (!filterSearchInput || filterSearchInput.trim() === "") {
            // If no search input, show all categories
            setFilteredCategories(filterCategories)
        } else {
            // Filter categories based on search input
            const filtered = filterCategories.filter((category) =>
                category.card_name
                    .toLowerCase()
                    .includes(filterSearchInput.toLowerCase())
            )
            setFilteredCategories(filtered)
        }
    }, [filterSearchInput, filterCategories])
    // to filter out the unique owners and show profile image across them
    const DEFAULT_AVATAR = [face1, face2, face3] // or any default image you want
    const uniqueOwners = useMemo(() => {
        if (!dealsData?.length) return []
        const ownerMap = new Map()
        dealsData?.forEach(lead => {
            if (lead.owner_id && !ownerMap.has(lead.owner_id)) {
                ownerMap.set(lead.owner_id, {
                    owner_id: lead.owner_id,
                    profile_img: lead.profile_img
                })
            }
        })
        return Array.from(ownerMap.values())
    }, [dealsData])

    const pipelineOptions = pipedLines.map((el) => ({
        value: el.id,
        label: el.pipeline_name,
    }))

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedFilterSearch(filterSearchInput)
            setFilterOffset(0)
        }, 400)

        return () => clearTimeout(timer)
    }, [filterSearchInput])

    // common advance filter api calls that will be needed everywhere
    const { leadOwner, lead_source, company, contacts } = useCommonData({
        leadOwner: true,
        leadSource: true,
        companies: true,
        contacts: true
    })

    const dealsStaticListOptions = [
        {
            key: "All Deals",
            icon: <FontAwesomeIcon
                icon={faUser}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Deals Created By Me",
            icon: <FontAwesomeIcon
                icon={faUserPlus}
                style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Deals Created Today",
            icon: <FontAwesomeIcon
                icon={faCalendarDay}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Deals Created this Month",
            icon: <FontAwesomeIcon
                icon={faCalendar}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Unqualified Deals",
            icon: <FontAwesomeIcon
                icon={faUserXmark}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Lost Deals",
            icon: <FontAwesomeIcon
                icon={faUserXmark}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "My Today Followup",
            icon: <FontAwesomeIcon icon={faUserXmark} style={{ width: "13px", height: "13px", marginRight: "9px" }} />
        },
    ]


    const dealImportFields = [
        { id: "deal_name", label: "Deal Name", required: true },
        { id: "currency_id", label: "Currency", required: true },
        { id: "contact_name", label: "Contact Name", required: true },
        { id: "pipeline", label: "Pipeline", required: true },
        { id: "pipeline_stage", label: "Pipeline Stage", required: true },

        { id: "owner", label: "Owner", required: true },
        {
            id: "expected_closure_date",
            label: "Expected Closure Date",
            required: true,
        },
        {
            id: "expected_closure_time",
            label: "Expected Closure Time",
            required: true,
        },
        { id: "requirement", label: "Requirement", required: true },
        { id: "product_services", label: "Product & Services", required: true },
        { id: "quantity", label: "Quantity", required: true },
        { id: "budget", label: "Budget", required: true },
        { id: "lead_source", label: "Lead Source", required: true },
        { id: "follow_up_date", label: "Follow Up Date", required: true },
        { id: "follow_up_time", label: "Follow Up Time", required: true },
        { id: "feedback", label: "Feedback", required: true },
    ];

    //  filter dropdown options
    const dropdownOptions = [
        { value: "contact_id", label: "Contact", option: contacts },
        { value: "owner_id", label: "Owner", option: leadOwner },
        { value: "company_id", label: "Company Name", option: company },
        {
            value: "pipeline_stage_id",
            label: "Pipeline Stage",
            option: pipelineStages,
        },
        { value: "closure_date", label: "Closure Date", type: "date-range" },
        { value: "followup_date", label: "FollowUp Date", type: "date-range" },
        { value: "lead_source_id", label: "Lead Source", option: lead_source },
        { value: "deal_no", label: "Deal Number" },
        { value: "created_at", label: "Created at", type: "date-range" },
    ]
    // sub filter dropdown option
    const subFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "contains", label: "Contains" },
        { value: "not_contains", label: "Not-Contains" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
        { value: "is_empty", label: "Is Empty" },
        { value: "is_not_empty", label: "Is Not Empty" },
        { value: "begins_with", label: "Begins With" },
        { value: "between", label: "Between" },
    ]
    const customSubFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
    ]


    //menulist for add new products and services button in dropdown
    const MenuList = (props) => {
        return (
            <>
                <components.MenuList {...props}>
                    {props.children}
                    <div
                        style={{
                            padding: "10px",
                            borderTop: "1px solid #ddd",
                            textAlign: "center",
                            cursor: "pointer",
                            color: "#2184ff",
                            fontSize: "0.9rem",
                        }}
                        onClick={() => {
                            console.log("permission", dealGrant?.isCreate)
                            if (!dealGrant?.isCreate) {
                                toast.warning("You are not authorized for this action!")
                                return
                            }
                            // trigger your modal open here
                            props.selectProps.onAddNew()
                        }}
                    >
                        + Create Pipeline
                    </div>
                </components.MenuList>
            </>
        )
    }
    // Debounced search effect with 500ms delay
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchInput)
            if (currView === "list") {
                setActiveOffset(0)
            }
        }, 500)

        return () => clearTimeout(timer)
    }, [searchInput, currView])

    // Clear search function
    const clearSearch = () => {
        setSearchInput("")
        setDebouncedSearch("")
        if (currView === "list") {
            setActiveOffset(0)
        }
    }

    useEffect(() => {
        if (filterCategories?.length > 0 && !isInitialized) {
            const lastHeading = localStorage.getItem("deals_last_heading")
            const existingFilter = filterCategories.find(
                (filter) => filter.card_name === lastHeading
            )
            setHeading(existingFilter ? lastHeading : "All Deals")
            setIsInitialized(true)
        }
    }, [filterCategories, isInitialized])

    useEffect(() => {
        if (
            dealsApiData &&
            dealsApiData.filter_data &&
            dealsApiData.filter_data[0] &&
            dealsApiData.filter_data[0].filter_values
        ) {
            const values = dealsApiData.filter_data[0].filter_values
            const parsedState = JSON.parse(values)
            const filteredArray = parsedState?.map((state) => {
                // Find the corresponding dropdown option to get the display label and potential nested options
                const dropdownOption = dropdownOptions.find(
                    (opt) => opt.value === state.label_name
                )

                let mappedOptions = null
                if (dropdownOption?.option && Array.isArray(dropdownOption.option)) {
                    // Replicate the mapping logic from handleAddFilter
                    if (dropdownOption.value === "owner_id") {
                        mappedOptions = dropdownOption.option.map((opt) => ({
                            value: opt.leadId,
                            label: opt.leadName,
                        }))
                    } else if (dropdownOption.value === "lead_source_id") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.lead_source_id,
                            label: opt.source_title,
                        }))
                    } else if (dropdownOption.value === "company_id") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.company_id,
                            label: opt.company_name,
                        }))
                    } else if (dropdownOption.value === "contact_id") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.contactId,
                            label: opt.contact_name,
                        }))
                    } else if (dropdownOption.value === "pipeline_stage_id") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.stage_id,
                            label: opt.stage_name,
                        }))
                    }
                }
                return {
                    id: state.label_name,
                    field: state.label_name,
                    label_name: dropdownOption ? dropdownOption.label : state.label_name,
                    option: mappedOptions,
                    subFilterType: state.label_query,
                    value:
                        state.label_query === "between"
                            ? { start: state.label_value[0], end: state.label_value[1] }
                            : state.label_value,
                }
            })
            setFilterState(filteredArray)
        } else {
            setFilterState([])
        }
        setAddedBy(dealsApiData?.pipeline_data?.["added_by"])
    }, [dealsApiData, queryKey])

    // Get display name for current filter type
    const getFilterDisplayName = () => {
        switch (currentFilterType) {
            case "all":
                return "All Deals"
            case "today":
                return "Today's Leads"
            case "month":
                return "This Month's Leads"
            case "unqualified":
                return "Unqualified Leads"
            case "lost":
                return "Lost Leads"
            case "created_by_me":
                return "Created By Me"
            default:
                return "All Deals"
        }
    }
    // useeeffect for fetching the created advance filters
    const fetchFilterCardCategories = async () => {
        try {
            const res = await GetRequest(
                `common/fetchFilterCard/${customer.customer_details?.customer_id}/deals?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            )

            if (res.status === "fail" || res.success === false) {
                return
            }

            setFilterCategories(res.data)

            // Calculate page count if total_count is available in response
            if (res.total_count) {
                setFilterPageCount(Math.ceil(res.total_count / filterLimit))
            }
        } catch (error) {
            toast.error("Error fetching filters")
        }
    }
    useEffect(() => {
        fetchFilterCardCategories()
    }, [heading])
    // edit handler for filter heading
    const handleFilterEdit = async () => {
        try {
            if (editValue === "") return
            if (filterData === null) return
            const updatePayload = {
                customer_id: customer.customer_details?.customer_id,
                user_login_id: customer.customer_details?.id,
                filter_id: filterData.id,
                card_name: editValue,
                description: "",
            }
            const res = await PutRequest(
                "contacts/updateFilterName",
                updatePayload,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            )
            if (res.status === false || res.success === "fail") {
                setFilterDropdown(false)
                return
            }
            if (res.status === "success") {
                setEditingId(null)
                fetchFilterCardCategories()
                setFilterDropdown(false)
            }
        } catch (error) {
            toast.error("Error Updating Filter")
        }
    }
    // delete handler for filter delete
    const handleFilterDelete = async () => {
        try {
            if (!canEdit_canDownload) {
                toast.warning("You are not authorised for this action!")
                setFilterDelete(false)
                return
            }
            if (filterData === null) return
            setIsDeleting(true)
            const res = await DeleteRequest(
                `common/deleteFilter/${filterData.id}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            )
            if (res.status === "fail") {
                toast.error(res.message)
                return
            }
            if (res.success === false) {
                toast.error(res.message)
            }
            setFilterDropdown(false)
            setFilterDelete(false)
            setIsDeleting(false)
            setHeading("All Leads")
            fetchFilterCardCategories()
            localStorage.setItem("deals_last_heading", "All Leads")
            toast.success(res.message)
        } catch (error) {
            toast.error("Error Deleting Filter")
            setIsDeleting(false)
        }
    }


    return (
        <>
            <div className="d-flex justify-content-between align-content-center px-0 w-100 py-0 pt-3 my-4 mb-2">
                <div
                    className="d-flex align-items-center gap-1"
                    style={{ width: "23%" }}
                >
                    <h3
                        className="mb-0 me-1"
                        style={{
                            fontWeight: 200,
                            fontSize: "22px",
                            textTransform: "capitalize",
                        }}
                    >
                        {heading}
                    </h3>
                    {/* heading filter dropdown */}
                    <ManageListDropdown
                        heading={heading}
                        setHeading={setHeading}
                        categories={filterCategories}
                        storageKey="deals_last_heading"
                        setTempFilterData={setTempFilterData}
                        onEdit={(c) => setFilterData(c)}
                        onDelete={(c) => {
                            setFilterData(c)
                            setFilterDelete(true)
                        }}
                        onUpdate={(c) => {
                            setFilterData(c)
                            handleFilterEdit()
                        }}
                        staticOptions={dealsStaticListOptions}
                        filterOffset={filterOffset}
                        setFilterOffset={setFilterOffset}
                        handleFilterPageChange={(newOffset) => setFilterOffset(newOffset.selected)}
                        filterPageCount={filterPageCount}
                        filterLimit={filterLimit}
                    />

                    {confirmFilterDelete && (
                        <DeleteModal
                            show={confirmFilterDelete}
                            onClose={() => setFilterDelete(false)}
                            onConfirm={() => handleFilterDelete(filterData)}
                            isLoading={isDeleting}
                            message={"Are you sure you want to delete all selected email ?"}
                        ></DeleteModal>
                    )}
                </div>

                <div className="avatar-list-stacked">
                    {uniqueOwners.slice(0, 5).map(owner => (
                        <div
                            key={owner.owner_id}
                            className="avatar avatar-md rounded-circle overflow-hidden"
                            style={Styles.avatar}
                        >
                            <img
                                src={owner.profile_img ? `${imageURL}${owner.profile_img}` : DEFAULT_AVATAR[Math.floor(Math.random() * DEFAULT_AVATAR.length)]}
                                alt="owner"
                                className="w-100 h-100"
                                style={{ objectFit: "cover" }}
                            />
                        </div>
                    ))}

                    {uniqueOwners.length > 5 && (
                        <a className="avatar avatar-md rounded-circle bg-primary text-fixed-white">
                            +{uniqueOwners.length - 5}
                        </a>
                    )}
                </div>

                {/* Header with pipeline selection and actions */}
                <div
                    className="d-flex align-content-center gap-1"
                    style={{ height: "35px" }}
                >
                    {/* Pipeline selection dropdown */}
                    {
                        pipelineOptions ?
                            <Select
                                options={pipelineOptions}
                                className="input-boxi"
                                value={pipelineOptions.find(
                                    (option) => option.value === selectedPipelineId
                                )}
                                onChange={(selectedOption) => {
                                    if (selectedOption.value === "add-new-pipeline") {
                                        setCreatePipeline(true)
                                    } else {
                                        setSelectedPipelineId(selectedOption.value)
                                    }
                                }}
                                components={{ MenuList }}
                                onAddNew={() => setCreatePipeline(true)}
                                styles={{
                                    ...customStyles,
                                    placeholder: (base) => ({
                                        ...base,
                                        margin: "0px",
                                    }),
                                    control: (base) => ({
                                        ...base,
                                        height: "34px",
                                        minWidth: "180px",
                                        width: "auto",
                                        minHeight: "34px",
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        textTransform: "capitalize",
                                        fontSize: "0.9rem",
                                    }),
                                    option: (base, state) => {
                                        const isCreateOption = state.data.value === "add-new-pipeline"

                                        return {
                                            ...base,
                                            backgroundColor: state.isSelected
                                                ? "#2684FF"
                                                : state.isFocused
                                                    ? "#DEEBFF"
                                                    : "white",
                                            color: isCreateOption ? "#2684FF" : base.color,
                                            fontWeight: 400,
                                            textTransform: "capitalize",
                                            fontSize: "0.9rem",
                                            "&:active": {
                                                backgroundColor: isCreateOption ? "#DEEBFF" : "#2684FF",
                                            },
                                        }
                                    },
                                    dropdownIndicator: (base) => ({
                                        ...base,
                                        padding: "4px 8px",
                                    }),
                                    clearIndicator: (base) => ({
                                        ...base,
                                        padding: "4px 8px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "34px",
                                        padding: "0 8px",
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        margin: 0,
                                        padding: 0,
                                    }),
                                }}
                                isSearchable={true}
                                placeholder="Select pipeline..."
                            />
                            :
                            <div style={{ width: "150px", height: "34px", animation: "shim 1.3s linear infinite", backgroundColor: "#e5e5e5", borderRadius: "5px" }}></div>
                    }
                    {/* Fixed width search bar to prevent resizing */}
                    <div
                        style={{
                            position: "relative",
                            width: "200px",
                            minWidth: "200px",
                        }}
                    >
                        <input
                            type="text"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            style={{
                                fontSize: "0.9rem",
                                paddingLeft: "36px",
                                paddingRight: searchInput ? "36px" : "12px",
                                width: "100%",
                            }}
                            className="form-control h-100"
                            placeholder="Search here.."
                        />
                        <i
                            className="fa-solid fa-magnifying-glass"
                            style={{
                                position: "absolute",
                                marginTop: "-26px",
                                zIndex: 1,
                                marginLeft: "13px",
                            }}
                        ></i>
                        {searchInput && (
                            <i
                                className="fa-solid fa-times"
                                onClick={clearSearch}
                                style={{
                                    position: "absolute",
                                    marginTop: "-26px",
                                    zIndex: 1,
                                    right: "13px",
                                    cursor: "pointer",
                                    color: "#6c757d",
                                }}
                                title="Clear search"
                            ></i>
                        )}
                    </div>

                    {/* List and card view toggle buttons */}
                    <div
                        className="px-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 5,
                            border: "1px solid #7a3a5e69",
                            borderRadius: "3px",
                            background: "#ffffff",
                            padding: "4px 8px",
                        }}
                    >
                        {/* Card View Button */}
                        <div
                            className=""
                            onClick={() => {
                                setCurrView("card")
                            }}
                            style={{
                                padding: "3px 5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                backgroundColor:
                                    currView === "card" ? "#e8e8e8" : "transparent",
                                transition: "background-color 0.2s ease",
                            }}
                        >
                            <IconLayout2
                                stroke={2}
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    color: currView === "card" ? "#212121" : "#212121",
                                }}
                            />
                        </div>
                        {/* List View Button */}
                        <div
                            className=""
                            onClick={() => {
                                setCurrView("list")
                            }}
                            style={{
                                padding: "3px 5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                backgroundColor:
                                    currView === "list" ? "#e8e8e8" : "transparent",
                                transition: "background-color 0.2s ease",
                            }}
                        >
                            <IconListDetails
                                stroke={2}
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    color: currView === "list" ? "#212121" : "#212121",
                                }}
                            />
                        </div>
                    </div>

                    {/* advance filtering */}
                    {
                        currView === 'list' &&
                        <Filter
                            filterDropdown={filterDropdown}
                            canEdit_canDownload={canEdit_canDownload}
                            setFilterDropdown={setFilterDropdown}
                            dropdownOptions={dropdownOptions}
                            filterState={filterStates}
                            setFilterState={setFilterState}
                            setHeading={setHeading}
                            subFilter={subFilter}
                            module_name={"deals"}
                            customSubFilter={customSubFilter}
                            pipelineId={selectedPipelineId}
                            setTempFilterData={setTempFilterData}
                            filterEndpoint={"common/filterQuery"}
                            applyQuery={"deals/applyFilter"}
                            view={currView == "list" ? "list" : "card"}
                        ></Filter>
                    }
                    {
                        currView === "list" &&
                        <ColumnConfigurator
                            columnOptions={columnOptions}
                            columns={columns}
                            setColumns={setColumns}
                            storageKey="dealColumns"
                            visibleKey="visibleDealColumns"
                        />
                    }
                    {canEdit_canDownload && (
                        <Dropdown
                            style={{ zIndex: 101 }}
                            as="div"
                            className="dropdownsWithoutToggle"
                        >
                            <Dropdown.Toggle as={Nav.Link} className="header-link">
                                <button
                                    className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                                    style={{
                                        fontSize: "1rem",
                                        alignItems: "center",
                                        height: "35px",
                                        width: "2.5rem",
                                    }}
                                >
                                    <FontAwesomeIcon
                                        style={{
                                            width: "15px",
                                            height: "15px",
                                        }}
                                        icon={faEllipsisVertical}
                                    />
                                </button>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                                className="defaultDropdown dropdown-menu-end"
                                style={{
                                    width: "11rem",
                                    padding: "12px 0px",
                                    right: "3.4rem",
                                }}
                            >
                                <Dropdown.Item
                                    onClick={() => {
                                        if (!dealGrant?.isImport) {
                                            toast.warning("You are not authorized for this action!");
                                            return;
                                        }
                                        navigate("/importdata", {
                                            state: {
                                                module_name: "deals",
                                                fieldData: [
                                                    {
                                                        title: "General Fields",
                                                        fields: dealImportFields.map((c) => c),
                                                    },
                                                ],
                                            },
                                        });
                                    }}
                                    className="d-flex align-items-center">
                                    <FontAwesomeIcon
                                        icon={faFileImport}
                                        style={{
                                            width: "16px",
                                            height: "16px",
                                            marginRight: "9px",
                                            color: "#5e5f60",
                                        }}
                                    />
                                    Import Data
                                </Dropdown.Item>
                                {/* can_download === can't download so don't get confused here. */}
                                {(permissionAssigned === "can_download" || canEdit_canDownload) && (
                                    <Dropdown.Item
                                        onClick={() => {
                                            if (!dealGrant?.isExport) {
                                                toast.warning("You are not authorized for this action.")
                                                return
                                            }
                                            handleExportData([], "deals", headers, extras)
                                        }}
                                        className="d-flex align-items-center">
                                        <FontAwesomeIcon
                                            icon={faFileExport}
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                marginRight: "9px",
                                                color: "#5e5f60",
                                            }}
                                        />
                                        Export Data
                                    </Dropdown.Item>
                                )}

                                <Dropdown.Item href="#" className="d-flex align-items-center">
                                    <FontAwesomeIcon
                                        icon={faFileCsv}
                                        style={{
                                            width: "16px",
                                            height: "16px",
                                            marginRight: "9px",
                                            color: "#5e5f60",
                                        }}
                                    />
                                    Template
                                </Dropdown.Item>
                                {/* Edit pipeline button */}

                                {selectedPipeline && (
                                    <Dropdown.Item
                                        onClick={() => {
                                            if (!dealGrant?.isEdit) {
                                                toast.warning("You are not authorized for this action.")
                                                return
                                            }
                                            // handleEditPipeline()
                                            const encodedId = encodePipelineId(selectedPipelineId)
                                            setEncodedId(encodedId)
                                            setEditPipeline(true)
                                        }}
                                        className="d-flex align-items-center"
                                    >
                                        <FontAwesomeIcon
                                            icon={faPencil}
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                marginRight: "10px",
                                                color: "#5e5f60",
                                            }}
                                        />
                                        Edit Pipeline
                                    </Dropdown.Item>
                                )}
                                {added_by === customer.customer_details?.id && (
                                    <Dropdown.Item
                                        href="#"
                                        className="d-flex align-items-center gap-1 text-start"
                                        onClick={() => setShareModal(true)}
                                    >
                                        <IconShare3
                                            stroke={2}
                                            size={18}
                                            style={{ color: "#5e5f60", marginRight: "9px" }}
                                        ></IconShare3>
                                        Share Pipeline
                                    </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    )}

                    {/* Add lead button */}
                    <Button
                        type="button"
                        className="btn btn-default"
                        style={{
                            height: "34px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={() => handleAddDeal(selectedStageId)}
                    >
                        <FontAwesomeIcon icon={faPlus} className="pe-1" /> Add
                    </Button>
                </div>
            </div>
            <div
                style={{
                    textAlign: "end",
                    paddingRight: "3px",
                    color: "#8798adcc",
                    fontWeight: "300",
                    fontSize: "11px",
                    textTransform: "capitalize",
                    marginBottom: "14px",
                }}
            >
                Customize Column View | Filter Contact | Short by ascending & Descending
                Order | Current View: {getFilterDisplayName()}
            </div>
            {selectedPipelineId !== null && shareModal && (
                <PipelineShareModal
                    shareModal={shareModal}
                    onShareClose={() => setShareModal(false)}
                    module_name={"deals"}
                    pipelineId={selectedPipelineId}
                    sharedUsers={parsedSharedUsers}
                />
            )}
        </>
    )
}

const Styles = {
    avatar: {
        border: "2px solid rgb(215 215 215)",
    },
}